import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./../Layout/Header";
import Footer from "./../Layout/Footer";
import axios from "axios";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import BaseUrl from "../../BaseUrl";

function Changepasswordpage() {
  const token = useSelector((state) => state.auth.auth);

  const [loader, setLoader] = useState(false);
  const [old_password, setOld_password] = useState("");
  const [new_password, setNew_password] = useState("");
  const [confirm_password, setConfirm_password] = useState("");
  const [fielderr, setFielderr] = useState("");

  const onChange = () => {
    const Change = new FormData();
    Change.append("old_password", old_password);
    Change.append("new_password", new_password);
    Change.append("confirm_password", confirm_password);
    setLoader(true);
    var config = {
      method: "post",
      url: `${BaseUrl.baseurl}/user/change/password`,
      data: Change,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };
    axios(config)
      .then(function (response) {
        if (response?.data?.status === true) {
          setLoader(false);
          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
      })
      .catch(function (error) {
        setLoader(false);
        console.log(error);
        setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title:
            error?.response?.data?.message === "old password does not matched"
              ? error?.response?.data?.message
              : "Validtion Fails",
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <Header />
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {/* <Profilesidebar /> */}
                <div className="col-xl-2 col-md-2" />
                <div className="col-xl-8 col-lg-8 m-b30">
                  <div className="job-bx job-profile">
                    <div className="job-bx-title clearfix">
                      <h5 className="font-weight-700 pull-left text-uppercase">
                        Change Password
                      </h5>
                      <Link
                        to={"/profile"}
                        className="site-button right-arrow button-sm float-right"
                      >
                        Back
                      </Link>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label>Old Password</label>
                          <input
                            type="password"
                            className="form-control"
                            onChange={(e) => setOld_password(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>New Password </label>
                          <input
                            type="password"
                            className="form-control"
                            onChange={(e) => setNew_password(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>Confirm New Password</label>
                          <input
                            type="password"
                            className="form-control"
                            onChange={(e) =>
                              setConfirm_password(e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className="col-lg-12 m-b10">
                        <button className="site-button" onClick={onChange}>
                          Update Password
                        </button>
                      </div>
                      <br />
                      <ul>
                        {fielderr
                          ? fielderr?.map((e) => (
                              <li>
                                <p className="text-danger">{e}</p>
                              </li>
                            ))
                          : null}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-md-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Changepasswordpage;
